<template>
    <Navbar />
    <router-view v-slot="{ Component }">
        <transition name="fade">
            <suspense timeout="0">
                <template #default>
                    <component :is="Component" :key="$route.path" />
                </template>
                <template #fallback>
                    <!-- loading indikator in center of element -->
                    <div class="w-full h-screen my-auto flex items-center justify-center">
                        <Loader2 class="mr-2 h-10 w-10 animate-spin" />
                    </div>
                </template>
            </suspense>
        </transition>
    </router-view>
    <Foot />
</template>

<script setup>
import { Loader2 } from "lucide-vue-next";
import Foot from '@/Components/Section/Foot.vue';
import Navbar from '@/Components/Section/Navbar.vue';
</script>

<style>
.fade-enter-active {
    transition: opacity 1s ease;
}

.fade-leave-active {
    transition: opacity 0s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
